export const Roles = {
    Read: 'OBU_MANAGER_READ',
    Write: 'OBU_MANAGER_WRITE',
};
